"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringToHash = void 0;

var stringToHash = function stringToHash(string, limit) {
  if (!string) {
    return null;
  }

  var hash = 0;

  for (var i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }

  return Math.abs(limit ? hash % limit : hash);
};

exports.stringToHash = stringToHash;